import { ReactElement } from 'react';
import NoSubOrgViewCard from 'views/pages/components/NoSubOrgViewCard';
import useSubOrgsViews from 'hooks/useSubOrgsViews';

const NoSubOrgRouteWrapper = ({ children }: { children: ReactElement }) => {
  const { isSubOrg, createdFrom } = useSubOrgsViews();

  if (isSubOrg) {
    return <NoSubOrgViewCard createdFrom={createdFrom} />;
  }

  return children;
};

export default NoSubOrgRouteWrapper;
